// set global config unless it was already set before (ie. by init.js)
if (typeof CONFIG === "undefined") {
    CONFIG = {
        s4pServerUrl: process.env.EXPO_PUBLIC_S4P_SERVER_URL || "",
        env: process.env.EXPO_PUBLIC_SPORK_ENV || "",
        debug: process.env.EXPO_PUBLIC_SPORK_DEBUG || "*",
        microsoftClientId: process.env.EXPO_PUBLIC_MICROSOFT_CLIENT_ID || "",
        featureMedicalRequestsEnabled:
            process.env.EXPO_PUBLIC_FEATURE_MEDICAL_REQUESTS_ENABLED === "true",
        parentWebUrl: process.env.EXPO_PUBLIC_PARENT_WEB_URL || "",
    };
    (globalThis as typeof globalThis & { CONFIG: typeof CONFIG }).CONFIG =
        CONFIG;
}
